<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="label-container" *ngIf="payload.properties.text?.value">
  <label class="flex jcc">
    <span class="field-label-content">
      <div style="display: inline" [innerHTML]="payload.properties.text?.value | tokenToDiv"></div>
      <span class="required" *ngIf="payload.properties.required.value">*</span>
      <fb-scribe-suggestion-indicator [target]="payload"></fb-scribe-suggestion-indicator>
      <fb-amendment-field-indicator />
    </span>
  </label>
</div>
<div class="label-container" *ngIf="payload.properties.content?.value">
  <label class="flex jcc subtitle">
    <span>
      <span [innerHTML]="payload.properties.content?.value | tokenToDiv"></span>
    </span>
  </label>
</div>
<div class="flex rel">
  <form class="flex w100p large-resolution">
    <mat-radio-group
      class="flex"
      [(ngModel)]="payload.properties.value.value"
      (ngModelChange)="clearScribeSuggestionMarker(payload)"
      [ngModelOptions]="{ standalone: true }"
    >
      <div class="flex responsive group-container" [ngClass]="{ 'multi-column': columns.length > 1 }">
        <div class="flex" *ngFor="let columnItems of columns; let colIndex = index" [attr.style]="getStyles()">
          <div class="flex flex-nosize control-container" *ngFor="let item of columnItems; let rowIndex = index">
            <mat-radio-button
              class="flex-nosize"
              [name]="payload.id + '_' + colIndex + '_' + rowIndex"
              [value]="item.properties?.value?.value"
              ngDefaultControl
            >
              <span [innerHTML]="item.properties.text.value | tokenToDiv"></span>
            </mat-radio-button>
          </div>
        </div>
      </div>
    </mat-radio-group>
  </form>
  <div *ngIf="payload.properties.required.value && isSubmitted && !isValid()" class="hint-required">
    This field is required
  </div>
</div>
